import { IInvestorDetails } from './registration/investorDetails';
import { ITaxDetails } from 'src/app/models/registration/taxDetails';

export interface IBankAccount {
    investorEntityId: number;
    bankId: number;
    bankName: string;
    bankAccountName: string;
    bankAccountNumber: string;
    isDefault: boolean;
    reference: string;
    isVerified: boolean;
}

export interface IInvestorEntityDetails {
    bankAccount: IBankAccount[];
    taxDetails: ITaxDetails;
    investorDetails: IInvestorDetails;
}

export enum InvestorStatus {
    Opening = 1,
    DetailsComplete = 2,
    Active = 3,
    Suspended = 4,
    Closing = 5,
    Closed = 6,
    IndividualStep = 100,
    IndividualInvestorStep = 110,
    IndividualPersonalStep = 120,
    IndividualVerificationStep = 130,
    IndividualBankStep = 140,
    IndividualContractStep = 150,
    JointStep = 200,
    JointInvestorStep = 210,
    JointPersonalStepOne = 220,
    JointVerificationStepOne = 230,
    JointPersonalStepTwo = 240,
    JointVerificationStepTwo = 250,
    JointBankStep = 260,
    JointContractStep = 270
}

export enum InvestorSubType {
    Investor = 200,
    KiwiSaverInvestor = 220
}